import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import Loading from "../layouts/LoadingContainer";
import NotFoundPage from "../pages/NotFoundPage";
import ErrorPage from "../pages/ErrorPage";

const Home = lazy(() => import("../pages/Home"));
const News = lazy(() => import("../pages/News"));
const NewsList = lazy(() => import("../pages/NewsList"));
const Hospital = lazy(() => import("../pages/Hospital"));
const Department = lazy(() => import("../pages/Department"));
const Experts = lazy(() => import("../pages/Experts"));
const OutpatientInformation = lazy(() =>
  import("../pages/OutpatientInformation")
);
const MedicalGuide = lazy(() => import("../pages/MedicalGuide"));
// const DeptDetails = lazy(() => import("../pages/DeptDetails"));
const MedicalInsurance = lazy(() => import("../pages/MedicalInsurance"));
const WorkStation = lazy(() => import("../pages/WorkStation"));
const ConsultationCenter = lazy(() => import("../pages/ConsultationCenter"));
const Navigation = lazy(() => import("../pages/Navigation"));
const ChatRedirect = lazy(() => import("../pages/ChatRedirect"));
const MPRedirect = lazy(() => import("../pages/MP_verify"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    errorElement: <ErrorPage />, // 捕获所有子路由错误
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<Loading />}>
            <Home />
          </Suspense>
        ),
      },
      {
        path: "newsList",
        element: (
          <Suspense fallback={<Loading />}>
            <NewsList />
          </Suspense>
        ),
      },
      {
        path: "newsList/:id",
        element: (
          <Suspense fallback={<Loading />}>
            <News />
          </Suspense>
        ),
      },

      {
        path: "zoujinsihui",
        element: (
          <Suspense fallback={<Loading />}>
            <Hospital />
          </Suspense>
        ),
      },
      {
        path: "sihuikeshi",
        element: (
          <Suspense fallback={<Loading />}>
            <Department />
          </Suspense>
        ),
      },
      // {
      //   path: "sihuikeshi/deptDetails",
      //   element: (
      //     <Suspense fallback={<Loading />}>
      //       <DeptDetails />
      //     </Suspense>
      //   ),
      // },
      {
        path: "zhuanjia",
        element: (
          <Suspense fallback={<Loading />}>
            <Experts />
          </Suspense>
        ),
      },
      {
        path: "shchuzhenxinxi",
        element: (
          <Suspense fallback={<Loading />}>
            <OutpatientInformation />
          </Suspense>
        ),
      },
      {
        path: "jiuyizhinan",
        element: (
          <Suspense fallback={<Loading />}>
            <MedicalGuide />
          </Suspense>
        ),
      },
      {
        path: "yibaofuwu",
        element: (
          <Suspense fallback={<Loading />}>
            <MedicalInsurance />
          </Suspense>
        ),
      },
      {
        path: "lumgzz",
        element: (
          <Suspense fallback={<Loading />}>
            <WorkStation />
          </Suspense>
        ),
      },
      {
        path: "huizhenzhongxin",
        element: (
          <Suspense fallback={<Loading />}>
            <ConsultationCenter />
          </Suspense>
        ),
      },
      {
        path: "laiyuandaohang",
        element: (
          <Suspense fallback={<Loading />}>
            <Navigation />
          </Suspense>
        ),
      },
      {
        path: "chat",
        element: (
          <Suspense fallback={<Loading />}>
            <ChatRedirect />
          </Suspense>
        ),
      },
      {
        path: "MP_verify_a0GFQbolQvw3WNRA",
        element: (
          <Suspense fallback={<Loading />}>
            <MPRedirect />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />, // 全局 404 处理
  },
]);
